import { Component, Input } from '@angular/core';
import { User } from '../../interfaces';
import { buildHeadshotUrl } from 'src/app/shared/utils/headshot.util';

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.scss'],
    standalone: false
})
export class UserInfoComponent {

  @Input() user!: Partial<User>

  getHeadshot(headshot?: string) {
    return buildHeadshotUrl(headshot)
  }
}
